module.exports = __webpack_public_path__ + "img/onassis-stegi-official-black-inline.8c400df2.svg";